(function () {
  var STORAGE_KEY = 'theme';
  var root = document.documentElement;

  function currentTheme() {
    return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function persistTheme(theme) {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {}
  }

  function syncToggles(theme) {
    var buttons = document.querySelectorAll('[data-theme-toggle]');
    var index = 0;

    for (index = 0; index < buttons.length; index += 1) {
      var button = buttons[index];
      var isDark = theme === 'dark';
      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      button.setAttribute('aria-label', isDark ? button.dataset.labelLight : button.dataset.labelDark);
    }
  }

  function syncMedia(theme) {
    var videos = document.querySelectorAll('video[data-theme-media]');
    var index = 0;

    for (index = 0; index < videos.length; index += 1) {
      var video = videos[index];
      var slot = video.getAttribute('data-theme-media');
      var active = !slot || slot === theme;

      if (active) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        video.pause();
      }
    }
  }

  function applyTheme(theme) {
    var isDark = theme === 'dark';
    var themeColor = document.querySelector('meta[name="theme-color"]');

    root.setAttribute('data-theme', theme);
    root.classList.toggle('dark', isDark);
    root.style.colorScheme = theme;
    root.style.backgroundColor = isDark ? '#121212' : '#ffffff';

    if (themeColor) {
      themeColor.setAttribute('content', isDark ? '#121212' : '#ffffff');
    }

    syncToggles(theme);
    syncMedia(theme);
    document.dispatchEvent(new CustomEvent('theme:change', { detail: { theme: theme } }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-theme-toggle]');
    if (!button) return;

    var nextTheme = currentTheme() === 'dark' ? 'light' : 'dark';
    persistTheme(nextTheme);
    applyTheme(nextTheme);
  });

  var colorSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
  var onSystemChange = function (event) {
    var stored = null;

    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch (error) {}

    if (stored === 'dark' || stored === 'light') return;
    applyTheme(event.matches ? 'dark' : 'light');
  };

  if (typeof colorSchemeQuery.addEventListener === 'function') {
    colorSchemeQuery.addEventListener('change', onSystemChange);
  }

  document.addEventListener('shopify:section:load', function () {
    applyTheme(currentTheme());
  });

  applyTheme(currentTheme());
})();
